import type { Context } from '@/overmind';
import { routes } from '@/overmind/machines/router';

export const handleArcGisSignInRoute = (context: Context) => ({
  [routes.signInArcgis]: async () => {
    await context.actions.handleArcGisSignInRoute();
  }
});
